import type { AasApiAdapter, CreateReplayInput } from "../adapter";
import { requestJson } from "../http";
import type { AgentReplay } from "../types";
import type { BackendReplay, BackendReplayCreateResponse } from "./backendTypes";

export function mapReplay(row: BackendReplay): AgentReplay {
	return {
		id: row.id,
		bundleId: row.bundleId ?? null,
		bundleSha256: row.bundleSha256 ?? null,
		sourceConversationId: row.sourceConversationId,
		sourceTitle: row.sourceTitle ?? null,
		replayConversationId: row.replayConversationId ?? null,
		status: row.status === "ok" || row.status === "error" ? row.status : "running",
		error: row.error ?? null,
		startedAt: row.startedAt,
		finishedAt: row.finishedAt ?? null,
	};
}

function replaysBase(slug: string): string {
	return `/api/agents/${encodeURIComponent(slug)}/replays`;
}

export const replaysApi: AasApiAdapter["replays"] = {
	async list(slug) {
		const rows = await requestJson<BackendReplay[]>(replaysBase(slug));
		return rows.map(mapReplay);
	},
	async create(slug, input: CreateReplayInput) {
		await requestJson<BackendReplayCreateResponse>(replaysBase(slug), {
			method: "POST",
			body: {
				conversationIds: input.conversationIds,
				...(input.deploymentId ? { deploymentId: input.deploymentId } : {}),
			},
		});
	},
};
